import "./LoadingScreen.css";
import Spinner from "../spinner/Spinner";

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <Spinner />
    </div>
  );
}
